export function AcceptInvitationFlow(){

    return <p>Guest Access Invitation Flow</p>

}